import { render, staticRenderFns } from "./AcuerdosDeServicio.vue?vue&type=template&id=53852552&scoped=true&"
import script from "./AcuerdosDeServicio.vue?vue&type=script&lang=js&"
export * from "./AcuerdosDeServicio.vue?vue&type=script&lang=js&"
import style0 from "./AcuerdosDeServicio.vue?vue&type=style&index=0&id=53852552&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53852552",
  null
  
)

export default component.exports